import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const HideFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function HideFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="m22.995 3.75-1.5-1.5L18.745 5c-1.92-1.41-4.23-2.25-6.75-2.25-5.41 0-9.84 3.78-11.5 9 .89 2.79 2.57 5.14 4.77 6.73l-1.77 1.77 1.5 1.5 18-18Zm-10.99 5.5a2.5 2.5 0 0 0-1.77 4.27l-2.12 2.12c-1-1-1.61-2.37-1.61-3.89 0-3.04 2.46-5.5 5.5-5.5 1.52 0 2.89.62 3.89 1.61l-2.12 2.12c-.45-.45-1.08-.73-1.77-.73ZM21.685 8.07 9.375 20.38c.84.2 1.72.31 2.63.31 5.41 0 9.84-3.72 11.5-8.94-.43-1.34-1.06-2.57-1.82-3.68Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default HideFilled;